// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__Le3a4","footer__container__mobile":"Footer_footer__container__mobile__7uiyl"};